module.exports = "/images/risk-slideshow-3-v2.png?a9c92cb7fea7d12a3c08bed5ec3d7a24";